import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../Redux/NewHire/Action";
import Navbar from "../Navbar/Navbar";
import "./ChangePassword.css";
import Swal from "sweetalert2";
import { MdCheckCircle, MdRadioButtonUnchecked } from "react-icons/md";
import { logoutAction } from "../../Redux/Auth/Action";


const ChangePassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginId = localStorage.getItem("loginId");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);


  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    loginId: loginId || "",
  });

  const clearPasswordInputFields = () => {
    setPasswordData({
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      loginId: loginId || "",
    });
  };


  const handleChange = (e) => {
    const { id, value } = e.target;

    setPasswordData((prevValues) => {
      const updatedValues = { ...prevValues, [id]: value };

      if (id === "newPassword" || id === "confirmPassword") {
        if (
          updatedValues.newPassword &&
          updatedValues.confirmPassword &&
          updatedValues.newPassword !== updatedValues.confirmPassword
        ) {
          setErrorMessage("New Password and Confirm Password did not match.");
          setIsSubmitDisabled(true);
        } else {
          setErrorMessage("");
          setIsSubmitDisabled(
            !updatedValues.oldPassword ||
            !updatedValues.newPassword ||
            !updatedValues.confirmPassword
          );
        }
      }
      return updatedValues;
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const handleSubmitPasswordChange = async (e) => {
    e.preventDefault();
    if (!passwordData.oldPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
      Swal.fire("Error", "All fields are required!", "error");
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(changePassword(passwordData))
        .then((response) => {
          if (response.statusMessage === "SUCCESS") {
            clearPasswordInputFields();
            Swal.fire({
              title: "Success!",
              text: response.statusDesc,
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            }).then(() => {
              dispatch(logoutAction());
              navigate("/signin");
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: response.statusDesc,
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error initiating the leave details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const password = passwordData.newPassword || "";

  const rules = {
    uppercase: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    length: password.length >= 8
  };

  const isPasswordValid =
    rules.uppercase &&
    rules.number &&
    rules.special &&
    rules.length;


  return (
    <div>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div className="row justify-content-center mt-4">
            <div className="col-md-4">
              <div className="card shadow">
                <div className="card-body">
                  <form onSubmit={handleSubmitPasswordChange}>
                    <div className="mb-3">
                      <label htmlFor="currentPassword" className="form-label fw-bold">
                        Current Password<span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="oldPassword"
                        placeholder="Enter current password"
                        value={passwordData.oldPassword || ''}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        onPaste={(e) => e.preventDefault()}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="newPassword" className="form-label fw-bold">
                        New Password <span className="text-danger">*</span>
                      </label>

                      <input
                        type="password"
                        className="form-control"
                        id="newPassword"
                        placeholder="Enter new password"
                        value={passwordData.newPassword || ''}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        onPaste={(e) => e.preventDefault()}
                      />

                      {/* Password Strength Checklist */}
                      <div className="mt-2 ps-2" style={{ fontSize: "0.9rem" }}>
                        {/* Uppercase */}
                        <div className={rules.uppercase ? "text-success" : "text-danger"}>
                          {rules.uppercase ? <MdCheckCircle size={18} /> : <MdRadioButtonUnchecked size={18} />}
                          &nbsp; Must contain at least <strong>one uppercase letter</strong>
                        </div>

                        {/* Number */}
                        <div className={rules.number ? "text-success" : "text-danger"}>
                          {rules.number ? <MdCheckCircle size={18} /> : <MdRadioButtonUnchecked size={18} />}
                          &nbsp; Must contain at least <strong>one number</strong>
                        </div>

                        {/* Special character */}
                        <div className={rules.special ? "text-success" : "text-danger"}>
                          {rules.special ? <MdCheckCircle size={18} /> : <MdRadioButtonUnchecked size={18} />}
                          &nbsp; Must contain at least <strong>one special character</strong>
                        </div>

                        {/* Length */}
                        <div className={rules.length ? "text-success" : "text-danger"}>
                          {rules.length ? <MdCheckCircle size={18} /> : <MdRadioButtonUnchecked size={18} />}
                          &nbsp; Minimum <strong>8 characters</strong>
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <label htmlFor="confirmPassword" className="form-label fw-bold">
                        Confirm Password<span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="confirmPassword"
                        placeholder="Confirm new password"
                        value={passwordData.confirmPassword || ''}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        onPaste={(e) => e.preventDefault()}
                      />
                    </div>
                    {errorMessage && <div className="text-danger mb-3">{errorMessage}</div>}
                    <div className="text-center">
                      <button type="submit" className="btn btn-primary" disabled={isSubmitDisabled || !isPasswordValid}>
                        SUBMIT
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
